import { RENN_FAKTOR } from '@etown/shared';

/** Umschalt rennt — links wie rechts. */
export const RENN_TASTEN: ReadonlySet<string> = new Set(['ShiftLeft', 'ShiftRight']);

interface Vektor {
  x: number;
  y: number;
}

/** Bewegungsvektor aufs Renntempo strecken: Betrag ueber 1 heisst rennen. */
export function mitTempo(vektor: Vektor, rennt: boolean): Vektor {
  if (!rennt) return vektor;
  return { x: vektor.x * RENN_FAKTOR, y: vektor.y * RENN_FAKTOR };
}

/** Kein Eingabegeraet darf schneller als Rennen — der Server lehnte es ab. */
export function tempoBegrenzen(vektor: Vektor): Vektor {
  const betrag = Math.hypot(vektor.x, vektor.y);
  if (betrag <= RENN_FAKTOR) return vektor;
  return { x: (vektor.x / betrag) * RENN_FAKTOR, y: (vektor.y / betrag) * RENN_FAKTOR };
}
